<template>
  <div class="upload-multiple-image">
    <span v-if="!readonly" class="mb-2"
      >จำนวนไฟล์ที่สามารถอัพโหลดได้&nbsp;{{ filterImage.length }}/{{ max }}</span
    >
    <v-layout wrap fill-height>
      <v-flex xs9 v-if="displayType == 'video' && filterImage.length < 1">
        <input
          v-if="!readonly"
          placeholder="กรอก public url"
          v-model="publicUrl"
          type="text"
          name=" public url"
        />
      </v-flex>
      <v-flex xs3 v-if="displayType == 'video' && filterImage.length < 1">
        <v-btn v-if="!readonly" color="primary" @click="addUrlImage">เพิ่ม</v-btn>
      </v-flex>
      <v-flex
        xs12
        d-flex
        class="pb-2"
        v-if="filterImage.length < max && !readonly"
        style="cursor: pointer"
      >
        <div
          class="btn-upload"
          style="border-radius: 10px; border: 4px dashed #eee; display: inline-table"
          onclick="document.getElementById('photoUploadInput').click()"
          @dragover.prevent
          @drop.prevent="onFileChange($event)"
        >
          <v-responsive>
            <v-layout style="height: 130px" column justify-center fill-height>
              <div class="text-xs-center">
                <v-icon large>camera_alt</v-icon>
                <br />
                {{ $t('select file to upload') }}
              </div>
            </v-layout>
          </v-responsive>
          <div class="pl-2">
            <span class="small" style="font-size: 12px; color: grey">{{
              $t('upload file size: {size}MB', { size: 10 })
            }}</span>
          </div>
        </div>
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
        lg3
        v-for="(image, index) in filterImage"
        :key="index"
        d-flex
        class="pr-2 pb-2 pl-2"
      >
        <div style="height: 100%; position: relative">
          <v-btn
            v-if="!readonly"
            icon
            small
            absolute
            color="primary"
            @click="removeImage(index)"
            style="right: 5px; top: 5px; z-index: 2"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
          <v-card flat tile class="d-flex" style="border-radius: 10px; border: 1px solid grey">
            <v-img
              v-if="image.type == 'image'"
              contain
              @click="openLink(image.url)"
              :src="image.url"
              aspect-ratio="1"
              style="cursor: pointer"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>

            <video v-else style="width: 150px; height: 150px" controls>
              <source :src="image.url" />
              Your browser does not support HTML5 video.
            </video>
          </v-card>
          <v-layout v-if="!readonly || displayType != 'video'">
            <v-flex class="text-xs-center">
              <v-btn
                v-if="index > 0 && !readonly"
                outline
                icon
                small
                color="primary"
                fab
                @click="onMove(index, 'left')"
                style="width: 30px; height: 30px"
              >
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-center">
              <v-btn
                v-if="index < lastIndex && !readonly"
                outline
                icon
                small
                color="primary"
                fab
                @click="onMove(index, 'right')"
                style="width: 30px; height: 30px"
              >
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>

    <!-- <div class="text-xs-left">
      <img
        :src="selectedImage"
        v-if="selectedImage && images.length > 0"
        alt
        class="responsive-img"
        style="border: 1px solid #eee; border-radius: 10px;max-height: 300px;"
      />
    </div>-->

    <!-- <ul class="image-list" style="margin-bottom: 0;position:relative;">
      <div style="overflow-x: auto; white-space: nowrap">
        <li
          class="item preview-img"
          v-for="(image, index) in images"
          :key="index"
          @click="selectedImage = image"
          :style="{backgroundImage: 'url(\'' + image + '\')'}"
          style="width: 90px; height: 90px; display: inline-block;vertical-align: top;border-radius: 10px;border: 1px solid #eee;margin-right: 5px;position: relative;    background-size: cover;background-repeat: no-repeat;background-position: center center;cursor: pointer"
        >
          <div
            class="btn btn-floating btn-small btn-outline-red btn-base-white"
            @click="removeImage(index)"
            style="position:absolute;right: 3px;top: 3px;"
          >
            <em class="fa fa-trash"/>
          </div>
        </li>
        <li
          slot="footer"
          v-if="images.length > 0 && images.length < limit"
          style="width: 90px; height: 90px; display: inline-block;vertical-align: top;"
        >
          <div
            class="btn-add text-xs-center"
            style="cursor: pointer;height: 100%"
            onclick="document.getElementById('photoUploadInput').click()"
          >
            <h5>
              <em class="fa fa-plus"/>
            </h5>
          </div>
        </li>
      </div>
    </ul>
    <div
      class="btn-add"
      v-if="images.length == 0"
      onclick="document.getElementById('photoUploadInput').click()"
      style="cursor: pointer"
    >
      <div class="text-xs-center" style="padding: 25px 0;">
        <a href="javascript:void(0);" class="btn btn-primary btn-xs">
          <span class="fa fa-camera middle"></span>
          {{$t('select file to upload')}}
        </a>
        <br />
        <span class="small" style="font-size: 12px;">{{$t('upload file size: {size}MB',{size: 10})}}</span>
      </div>
    </div>-->
    <div class="form-control has-error" v-if="isAlert">
      <span class="text-error">{{ $t('Please try to upload file again') }}</span>
    </div>
    <div class="form-control has-error">
      <span class="text-error" v-show="errors.has('photoUpload')">{{
        errors.first('photoUpload')
      }}</span>
    </div>
    <input
      type="file"
      multiple
      class="form-control-file pt-2"
      name="photoUpload"
      id="photoUploadInput"
      data-vv-as="File"
      :accept="fileTypeAccept.accept"
      @change="onFileChange($event)"
      :v-validate="fileTypeAccept.validate"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />

    <v-dialog v-model="showCrop" :max-width="600" hide-overlay :disabled="!imgSrc" persistent>
      <img
        v-show="cropSrc"
        slot="activator"
        :src="cropSrc"
        style="width: 200px; border: 1px solid gray"
        alt="Cropped Image"
      />
      <v-card>
        <v-card-title> <span class="headline">Crop tool</span> </v-card-title>
        <v-card-text>
          <vue-cropper
            ref="cropper"
            :guides="false"
            :view-mode="1"
            drag-mode="move"
            :auto-crop-area="1"
            :min-container-width="250"
            :min-container-height="180"
            :background="true"
            :src="imgSrc"
            :modal="true"
            :img-style="{ width: '400px', height: '400px' }"
            :highlight="true"
            :aspect-ratio="apectratio"
          />
        </v-card-text>
        <v-card-actions>
          <!-- <v-tooltip> -->
          <v-btn color="primary" @click="changeCropImage">{{ $t('Crop') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="setAspectRatio(4 / 5)" outline>16 : 9</v-btn>
          <v-btn color="primary" @click="setAspectRatio(1)" outline>1 : 1</v-btn>
          <v-btn color="primary" @click="setAspectRatio(1.91 / 1)" outline>1.91 : 1</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            outline
            @click="
              showCrop = false
              filename = ''
              imgSrc = null
            "
            flat
            >{{ $t('cancel') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  props: ['value', 'max', 'readonly', 'displayType'],
  data: function () {
    return {
      limit: this.max,
      images: this.value,
      isAlert: false,
      selectedImage: null,
      showDrag: false,
      publicUrl: '',
      imgSrc: null,
      showCrop: false,
      cropSrc: null,
      apectratio: 4 / 5,
      filename: ''
    }
  },
  components: {
    VueCropper
  },
  mounted: function () {
    let vm = this
    // if (vm.images.length >= 1) {
    //   vm.selectedImage = vm.images[0]
    // }
  },
  computed: {
    lastIndex: function () {
      return this.images ? this.images.length - 1 : 0
    },
    filterImage() {
      if (this.displayType) {
        return this.images ? this.images.filter((f) => f.type == this.displayType) : []
      }
    },
    fileTypeAccept() {
      let result = { accept: null, validate: null }
      if (this.displayType) {
        if (this.displayType == 'image') {
          result.accept = '.jpg'
          result.validate = 'image|size:8192|mimes:image/jpeg,image/jpg'
        } else {
          result.accept = '.jpg'
          result.validate = 'image|video|size:8192|mimes:image/jpeg,image/jpg'
        }
      } else {
        result.accept = '.jpg'
        result.validate = 'image|video|size:8192|mimes:image/jpeg,image/jpg'
      }
      return result
    }
  },
  methods: {
    setAspectRatio(ratio) {
      this.$refs.cropper.setAspectRatio(ratio)
    },
    changeCropImage() {
      this.$refs.cropper
        .getCroppedCanvas({
          maxWidth: 1440
        })
        .toBlob(
          (blob) => {
            // this.cropImg = URL.createObjectURL(blob);
            // this.croppedBlob = blob;
            var file = this.blobToFile(blob, this.filename)
            this.createImage(file)
            this.showCrop = false
          },
          'image/jpeg',
          0.95
        )
    },
    blobToFile(theBlob, fileName) {
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.images.splice(index, 0, vm.images.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.images.splice(index, 0, vm.images.splice(index + 1, 1)[0])
      }
      this.$emit('input', this.images)
    },
    fileResize: function (file, callback) {
      let vm = this
      var reader = new FileReader()
      reader.onloadend = function () {
        var tempImg = new Image()
        tempImg.src = reader.result
        tempImg.onload = function () {
          var MAX_WIDTH = 1440
          var MAX_HEIGHT = 1440
          var tempW = tempImg.width
          var tempH = tempImg.height
          if (tempW > tempH) {
            if (tempW > MAX_WIDTH) {
              tempH *= MAX_WIDTH / tempW
              tempW = MAX_WIDTH
            }
          } else {
            if (tempH > MAX_HEIGHT) {
              tempW *= MAX_HEIGHT / tempH
              tempH = MAX_HEIGHT
            }
          }

          var canvas = document.createElement('canvas')
          canvas.width = tempW
          canvas.height = tempH
          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tempW, tempH)
          var dataURL = canvas.toDataURL('image/jpeg')
          var data = 'image=' + dataURL
          var obj = vm.dataURItoBlob(data)
          obj.name = file.name
          callback(obj)
        }
      }
      reader.readAsDataURL(file)
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    checkMove: function (event) {
      let vm = this
      vm.$emit('input', vm.images)
    },
    onFileChange: function (event) {
      let vm = this
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      if (files.length > vm.max - vm.filterImage.length)
        return vm.$swal.fire({
          type: 'error',
          text: `สามารถอัพโหลดเนื้อหาได้ไม่เกิน ${vm.max} จำนวน`
        })

      for (let file of files) {
        if (typeof FileReader === 'function') {
          const reader = new FileReader()
          reader.onload = (event) => {
            this.imgSrc = event.target.result
            this.filename = file.name.replace(/,/g, '')
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result)
            this.showCrop = true
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
        // if (['video/mp4'].includes(file.type)) {
        //   vm.createImage(file)
        // } else {
        //   vm.fileResize(file, function(obj) {
        //     vm.createImage(obj)
        //   })
        // }
      }
      event.target.value = ''
    },
    createImage(file) {
      this.upload(file)
    },
    upload(file) {
      let data = {
        name: file.name.replace(/,/g, ''),
        type: file.type,
        file: file
      }
      let vm = this
      vm.$store.dispatch('loading')
      api.getSignedRequest(data, function (error, url) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let file_type
        if (file.type.includes('image/')) {
          file_type = 'image'
        } else {
          file_type = 'video'
        }

        url = encodeURI(url)
        vm.images.push({ url: url, type: file_type })
        // if (vm.images.length >= 1 && vm.selectedImage == null) {
        //     vm.selectedImage = vm.images[0]
        // }
        vm.selectedImage = url
        vm.$emit('input', vm.images)
        vm.$store.dispatch('loading')
        // vm.$emit('onUploaded',url)
      })
    },
    removeImage: function (index) {
      let vm = this
      if (index > 0) {
        vm.selectedImage = vm.images[index - 1]
      } else if (vm.images.length > 0) {
        vm.selectedImage = vm.images[0]
      } else {
        vm.selectedImage = null
      }
      // if (vm.images[index] === vm.selectedImage) {
      //     vm.selectedImage = null
      // }
      vm.images.splice(index, 1)

      vm.$emit('input', vm.images)
    },
    addUrlImage() {
      if (!this.publicUrl) {
        return
      }

      let validUrl = this.isValidHttpUrl(this.publicUrl)
      if (validUrl) {
        // check type
        let file_type = this.get_url_extension(this.publicUrl)
        if (['jpg', 'png', 'jpeg', 'gif'].includes(file_type)) {
          file_type = 'image'
        } else {
          file_type = 'video'
        }
        this.images.push({ url: this.publicUrl, type: file_type })
        this.publicUrl = ''
      }
    },
    isValidHttpUrl(string) {
      let url

      try {
        url = new URL(string)
      } catch (_) {
        return false
      }

      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    get_url_extension(url) {
      return url.split(/[#?]/)[0].split('.').pop().trim()
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.images = []
        $.each(newVal, function (index, val) {
          vm.images.push(val)
        })

        if (vm.images.length >= 1) {
          vm.selectedImage = vm.images[0]
        } else {
          vm.selectedImage = null
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn-upload {
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/InstagramManager/UploadMultipleFile.vue